import { useTranslation } from 'react-i18next';
import type { ClientStatus } from '@/shared/types/api/parcels';
import { StatusChip } from '@/shared/ui/chips/StatusChip';

type ClientStatusChipProps = {
  status: ClientStatus;
  className?: string;
};

// Color mapping:
// - IN_PROGRESS: amber (work-in-progress, action expected from the user)
// - SORTING: slate (idle in the warehouse queue)
// - party-borne statuses: sky/blue for in-transit, orange for customs
//   (kept visually distinct from amber IN_PROGRESS so users can tell them
//   apart at a glance), emerald for delivered.
const CLIENT_STATUS_STYLES: Record<ClientStatus, string> = {
  IN_PROGRESS: 'bg-amber-100 text-amber-800 border-amber-200',
  SORTING: 'bg-slate-100 text-slate-700 border-slate-200',
  COLLECTING: 'bg-sky-100 text-sky-800 border-sky-200',
  SHIPPING: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  ON_THE_WAY: 'bg-blue-100 text-blue-800 border-blue-200',
  ON_CUSTOMS: 'bg-orange-100 text-orange-800 border-orange-200',
  LOCAL_ON_THE_WAY: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  SHIPMENT_ON_CUSTOMERS: 'bg-emerald-100 text-emerald-800 border-emerald-200',
};

export const ClientStatusChip = ({ status, className }: ClientStatusChipProps) => {
  const { t } = useTranslation('clientStatus');
  return (
    <StatusChip toneClass={CLIENT_STATUS_STYLES[status]} label={t(status)} className={className} />
  );
};
